import React from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Container,  Row, Col } from "react-bootstrap";
import "./HomeTeam.scss";
import {
    CONTACT_FORM_PAGE_URL,
    CONTACT_PAGE_URL,
    TEAM_PAGE_URL
} from "@Components/common/site/constants";
import CustomButton from "@Components/calendly/book-a-video-call"
import ModelForm from "@Components/ModelForm/ModelForm";
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import {ImageModule} from "@Components/common/Image_Module";

const HomeTeam = (props) => {
    return (
        <React.Fragment>
            <section className="home-team">
                {/* {JSON.stringify(props.Offices)} */}
                <Container>
                    <Row>
                        {props.Offices?.map((item, index) => {
                            let processedImages = JSON.stringify({});
                            if (item?.imagetransforms?.Image_Transforms) {
                                processedImages = item.imagetransforms.Image_Transforms;
                            }
                            // console.log("#######", item);
                            return (

                                <Col lg={6}>
                                    <div className="person-detail person1">
                                        <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>

                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                <span className="small-head">{item.Office_Address}</span>
                                            </ScrollAnimation>

                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                <h2>
                                                    <Link className="email-line-height" to={CONTACT_PAGE_URL.alias + '/' + item.URL + CONTACT_FORM_PAGE_URL.alias}>Email {item.Office_Name}</Link>
                                                    </h2> 
                                                    <h4>
                                                    <span className="item-sale item-first">Sales:</span>    
                                                    <a title="Sales" href={"tel:" + item.Sales_Phone}><span className="stroke-text">{item.Sales_Phone}</span></a>
                                                    </h4>
                                                    <h4>
                                                        <span className="item-sale">Lettings:</span>
                                                    <a title="Lettings" href={"tel:" + item.Lettings_Phone}><span className="stroke-text">{item.Lettings_Phone}</span></a>
                                                </h4>
                                            </ScrollAnimation>

                                            <div className="person-info">

                                                <div className="person-img">
                                                    <Link to={TEAM_PAGE_URL.alias + '/' + item.Choose_Person.URL}>
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            {/* <picture>
                                                            <source media="(min-width:992px)" srcSet={item.Choose_Person.Image?.url} />
                                                            <source media="(min-width:768px)" srcSet={item.Choose_Person.Image?.url} />
                                                            <img src={item.Choose_Person.Image?.url} alt={item.Choose_Person.Image?.alternativeText} />
                                                        </picture> */}
                                                            <ImageModule ImageSrc={item.Choose_Person.Image} attr={{ alt: item.Choose_Person.Name }} ggfx_results={item.Choose_Person.ggfx_results} imagename="team.Image.choose" strapi_id={item.Choose_Person?.id} />
                                                            {/* <ImageTransform imagesources={item.Choose_Person.Image?.url} renderer="srcSet" imagename='team.Image.choose'
                                                                attr={{ alt: item.Choose_Person?.Image?.alternativeText, className: '' }}
                                                                imagetransformresult={processedImages} id={item.Choose_Person?.id} >

                                                            </ImageTransform> */}
                                                        </ScrollAnimation>
                                                    </Link>

                                                </div>
                                                <div className="person-content">
                                                    <Link to={TEAM_PAGE_URL.alias + '/' + item.Choose_Person.URL}>
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <p className="name">{item.Choose_Person.Name}</p>
                                                        </ScrollAnimation>
                                                    </Link>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <p className="designation">{item.Choose_Person.Designation}</p>
                                                    </ScrollAnimation>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <p className="person-links"><ModelForm page="" Name={item.Choose_Person?.Name} mailid={item.Choose_Person?.Email} /> {item.Choose_Person?.Book_A_Video ? " / " : ""} {item.Choose_Person?.Book_A_Video ? <CustomButton url={item.Choose_Person?.Book_A_Video} /> : ""}</p>
                                                    </ScrollAnimation>

                                                </div>
                                            </div>
                                        </ScrollAnimation>
                                    </div>
                                    {/* <hr className="horizontal-line" /> */}
                                </Col>
                            )
                        })}
                        {/* <Col lg={6}>
                            <div className="person-detail person2">
                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><span className="small-head">Theme, OX9 3BH</span></ScrollAnimation>
                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><h2>Email Thame <span className="stroke-text">01844 399292</span></h2></ScrollAnimation>
                                <div className="person-info">
                                    <div className="person-img">
                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                    <picture>
                                        <source media="(min-width:992px)" srcSet={PersonImgDesktop2} />
                                        <source media="(min-width:768px)" srcSet={PersonImgTablet2} />
                                        <img src={PersonImgMobile2} alt="" />
                                    </picture>
                                    </ScrollAnimation>
                                    </div>
                                    <div className="person-content">
                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="name">Catherine Witt</p></ScrollAnimation>
                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="designation">Thame Senior Lettings</p></ScrollAnimation>
                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="person-links"><Link href="mailto:" className="btn-text-link">Email</Link> / <Link href="#" className="btn-text-link">Book a Video Call</Link></p></ScrollAnimation>
                                    </div>
                                </div>
                            </div>
                        </Col> */}
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}

export default HomeTeam;